// =========================
// lib/featureRegistry.js — PLATFORM-003 (frontend display mirror)
//
// Presentation-only mirror of the runtime feature-management vocabulary. The
// ENABLEMENT DECISION is server-authoritative (admin-set-feature-state /
// admin-get-feature-registry compute it); this module only provides constants +
// label/summary helpers so the Admin Feature Management panel can render status,
// audience, lifecycle, and prerequisite warnings consistently. It NEVER decides
// whether a feature may be enabled.
// =========================

export const AUDIENCES = Object.freeze([
  'internal',
  'controlled_cohort',
  'beta',
  'public',
]);

export const LIFECYCLE_STAGES = Object.freeze([
  'engineering',
  'merged',
  'production_deployed',
  'production_verified',
  'runtime_enabled',
  'observation',
  'general_availability',
  'retired',
]);

const AUDIENCE_LABELS = {
  internal: 'Internal',
  controlled_cohort: 'Controlled Cohort',
  beta: 'Beta',
  public: 'Public',
};

export function audienceLabel(audience) {
  return AUDIENCE_LABELS[audience] || audience || '—';
}

export function lifecycleLabel(stage) {
  if (!stage) return '—';
  return stage
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

// The prerequisite warnings to show for a registry row. Reads the server-computed
// `enablement.reasons`; returns [] when the feature is enable-ready. Never
// recomputes the gate — display only.
export function prerequisiteWarnings(flag) {
  if (!flag || !flag.enablement) return [];
  return flag.enablement.allowed ? [] : (flag.enablement.reasons || []);
}

// Whether the Enable action should be offered for a (currently disabled) row.
// A disabled feature can be enabled only when the server says its prerequisites
// are satisfied. An enabled feature can always be disabled.
export function canOfferEnable(flag) {
  if (!flag) return false;
  if (flag.enabled) return true; // already on → the offer is "disable"
  return Boolean(flag.enablement && flag.enablement.allowed);
}
